import { ListSortDirection, Sort } from "../../models/api/sort";
import { LegalEntityDonatorMemberDTO, LegalEntityDonatorMemberSTO } from "../../models/legal-entity-donators-members";
import { BaseApiService } from "../base/base-api.service";

export class LegalEntityDonatorsMembersApiService extends BaseApiService<
  LegalEntityDonatorMemberDTO,
  LegalEntityDonatorMemberSTO
> {
  constructor() {
    super({
      servicePath: "/LegalEntityDonatorsMembers",
      loadItemsPath: "/GetLegalEntityDonatorsMembers",
      saveItemsPath: "/SaveLegalEntityDonatorsMembers",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
